export const AdminMenuList = [
  {
    title: "Dashboard",
    iconStyle: imagepaths.DashboardWhiteIcon,
    iconActive: imagepaths.DashboardWhiteIconActive,
    to: "/app/home",
    id: "home",
  },
  {
    title: "Employees",
    iconStyle: imagepaths.LeadsIconWhite,
    iconActive: imagepaths.LeadsIconWhiteActive,
    to: "/app/employees",
    id: ["employees"],
  },
  {
    title: "Agents",
    iconStyle: imagepaths.AgentIconWhite,
    iconActive: imagepaths.AgentIconWhiteActive,
    to: "/app/agents",
    id: ["agents"],
  },
  {
    title: "Connectors",
    iconStyle: imagepaths.LeadsIconWhite,
    iconActive: imagepaths.LeadsIconWhiteActive,
    to: "/app/connectors",
    id: ["connectors", "connectorsview"],
  },
  {
    title: "Applications",
    iconStyle: imagepaths.applicationImg,
    iconActive: imagepaths.applicationActiveImg,
    to: "/app/applications",
    id: "applications",
  },
  {
    title: "Lead Management",
    iconStyle: imagepaths.LeadsIconWhite,
    iconActive: imagepaths.LeadsIconWhiteActive,
    to: "/app/leadmanagement",
    id: ["leadmanagement"],
  },
  {
    title: "Payout Details",
    iconStyle: imagepaths.WalletIconWhite,
    iconActive: imagepaths.WalletIconWhiteActive,
    to: "/app/myearnings",
    id: "myearnings",
  },
  {
    title: "Policies",
    iconStyle: imagepaths.shieldIconWhite,
    iconActive: imagepaths.shieldIconWhiteActive,
    to: "/app/connectorhome",
    id: ["dataPrivacyModal", "dataStorageModal", "rbipolicy"],
    classChange: "mm-collapse",
    content: [
      {
        title: "Privacy Policy",
        iconStyle: imagepaths.PrivacyPolicyWhite,
        iconActive: imagepaths.PrivacyPolicyWhiteActive,
        to: "/app/connectorhome",
        classChange: "menu-popup",
        id: "dataPrivacyModal",
        showTitle: true
      },
      {
        title: "Terms and Conditions",
        iconStyle: imagepaths.MasterDataIconWhite,
        iconActive: imagepaths.MasterDataIconWhiteActive,
        to: "/app/connectorhome",
        classChange: "menu-popup",
        id: "dataStorageModal",
      }
    ],
  },
];
